import { formatElapsedTime } from "@/lib/elapsedTime";
import React, { useEffect, useRef, useState } from "react";
import { Clock3 } from "lucide-react";

export default function OpenCallTimer({ elapsedSeconds }) {
  const valid = Number.isInteger(elapsedSeconds) && elapsedSeconds >= 0;
  const [age, setAge] = useState(valid ? elapsedSeconds : null);
  const anchor = useRef({ age: elapsedSeconds, time: performance.now() });
  useEffect(() => {
    anchor.current = { age: valid ? elapsedSeconds : null, time: performance.now() };
    setAge(valid ? elapsedSeconds : null);
  }, [elapsedSeconds, valid]);
  useEffect(() => {
    const timer = setInterval(() => {
      if (anchor.current.age !== null && Number.isInteger(anchor.current.age)) setAge(anchor.current.age + Math.floor((performance.now() - anchor.current.time) / 1000));
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <span className="inline-flex items-center gap-2 text-sm font-medium tabular-nums" data-testid="open-call-timer"><Clock3 className="h-4 w-4 text-accent" aria-hidden="true" />
    {age === null ? "Time unavailable" : <><span className="text-muted-foreground text-xs">Open for</span><span className="font-mono">{formatElapsedTime(age)}</span></>}
  </span>;
}
